export default {
    page_title: "Kevi | Coupons List",
    title: "Coupons",
    export_aria_label: "Export coupons",
    export_button: "Export",
    table: {
        coupon: "Coupon",
        client: "Client",
        phone: "Phone",
        email: "Email",
        created_at: "Created At",
        validity_between: "Validity Between",
        used_at: "Used At",
        automation: "Automation",
    },
    badges: {
        used: "Used:",
        expired: "Expired",
        valid_until: "Valid until",
    },
    empty: {
        no_name: "Name not provided",
        not_used: "Not used",
        no_automation: "Created without automation",
        no_data_for_period: "No data for this period",
    },
    filters: {
        client_segment: "Client segment",
        coupon_code: "Coupon code",
        created_date: "Creation date",
        expiration_date: "Expiration date",
        used_date: "Usage date",
        automation: "Automation",
        status: "Status",
        available: "Available",
        used: "Used",
        expired: "Expired",
    },
    export: {
        status_before_validity: "Before validity",
        status_used: "Used",
        status_expired: "Expired",
        status_valid: "Valid",
        column_code: "Code",
        column_coupon: "Coupon",
        column_status: "Status",
        column_valid_from: "Validity Start",
        column_valid_until: "Validity End",
        column_used_at: "Used At",
        column_client_name: "Client Name",
        column_client_phone: "Client Phone",
        column_client_email: "Client E-mail",
        column_automation: "Automation",
    },
    conjunction_and: "and",
};
